import DefaultValidation from '@/services/validations/DefaultValidation';
import Message from '@/models/Message';

export default class MotivoNaoVendaValidation extends DefaultValidation{

    constructor(msgs) {
        super(msgs);
    }

    validate(model, refs) {
        let validated = true;
        let minfotos = parseInt(model.minimofotos);

        if (!model.descricao) {
            refs.descricaoInput.focusedOut = true;
            validated = false;
        }

        if (!model.idmotivonaovendaerp) {
            refs.idErpInput.focusedOut = true;
            validated = false;
        }

        if (isNaN(minfotos) || minfotos < 0) {
            refs.minFotosInput.focusedOut = true;
            validated = false;
        }

        if (!validated) {
            this.showMessage(new Message('alert', 'msg-campos-obrigatorios', true));
        }
        
        return validated;
    }

}